<template>
  <b-form-group class="mb-2">
    <label class="mr-2">{{ trans('from') }}:</label>
    <span v-if="type.indexOf('sms') >= 0 || type == 'both'" class="mr-4">
      {{ organization.from_mobile }}
      <small class="text-muted">
        <i class="fa fa-fw fa-info-circle" id="from_mobile"></i>
      </small>
      <b-tooltip target="from_mobile" triggers="hover">
        {{ trans('from_mobile_about') }}
      </b-tooltip>
    </span>
    <span v-if="type.indexOf('email') >= 0 || type == 'both'">
      <b-dropdown variant="link" class="from-email-dropdown">
        <template #button-content>
          {{ fromName || organization.alias || organization.name }}
          &lt;{{ value }}&gt;
        </template>
        <b-dropdown-item v-if="organization.verified_from_emails.length > 0" v-for="email in organization.verified_from_emails" v-bind:key="email" :active="value == email" @click="$emit('input', email)">
          {{ fromName || organization.alias || organization.name }}
          &lt;{{ email }}&gt;
        </b-dropdown-item>
        <b-dropdown-item v-if="organization.verified_from_emails.length == 0">
          {{ fromName || organization.alias || organization.name }}
          &lt;{{ value }}&gt;
        </b-dropdown-item>
      </b-dropdown>
      <small class="text-muted">
        <i class="fa fa-fw fa-info-circle" id="from_email"></i>
      </small>
      <b-tooltip target="from_email" triggers="hover">
        {{ trans('from_email_about') }}
      </b-tooltip>
    </span>
  </b-form-group>
</template>

<script>
  export default {
    props: {
      organization: Object,
      type: String,
      value: String,
      fromName: String,
    },
    data() {
      return {
        trans: trans,
      }
    },
    mounted() {
      window.fromComponent = this
    }
  }
</script>